import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  const defaultLinks = [{
    id: "home",
    label: "HOME",
    href: "/HomePage"
  }, {
    id: "services",
    label: "SERVICES",
    href: "/#services"
  }, {
    id: "gallery",
    label: "GALLERY",
    href: "/#gallery"
  }, {
    id: "contact",
    label: "CONTACT",
    href: "/#contact"
  }];
  const linksToRender = menuItems && menuItems.length > 0 ? menuItems : defaultLinks;
  return <>
      {}
      <header className="sticky top-0 z-50 w-full flex justify-center pointer-events-none">
        {}
        <div className={cn("pointer-events-auto transition-all duration-500 ease-in-out flex items-center justify-between px-6 py-3 border border-transparent", isScrolled ? "w-[95%] max-w-7xl rounded-none mt-4 bg-background/80 backdrop-blur-xl border-white/10 shadow-none" : "w-full rounded-none mt-0 bg-background border-b-white/10")}>
          {}
          <div className="flex-shrink-0">
            <Link to="/HomePage" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/quinn_studio_logo.png" alt="Quinn Studio" className="h-7 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div className="hidden md:flex items-center justify-center flex-1 px-8">
            <NavigationMenu>
              <NavigationMenuList className="gap-8">
                {loading ? [1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-white/5 animate-pulse rounded-none" data-index={i} />) : linksToRender.map((item, i) => <NavigationMenuItem key={item.id || i}>
                      <NavigationMenuLink asChild>
                        <Link to={item.href || "#"} className="text-[13px] font-bold uppercase tracking-[0.1em] text-white hover:text-white/60 transition-colors font-sans" data-index={i}>
                          {item.label}
                        </Link>
                      </NavigationMenuLink>
                    </NavigationMenuItem>)}
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          {}
          <div className="flex items-center gap-4">
            <Button asChild variant="default" className="hidden sm:inline-flex bg-white text-background hover:bg-neutral-200 rounded-none px-6 font-bold tracking-widest uppercase text-xs">
              <Link to="/#initiate-your-project">Get a Quote</Link>
            </Button>

            {}
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white hover:bg-white/5 rounded-none" aria-label="Toggle menu">
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </header>

      {}
      <div className={cn("fixed inset-0 z-40 bg-background pt-24 px-6 transition-transform duration-300 ease-in-out md:hidden", isMobileMenuOpen ? "translate-y-0" : "-translate-y-full")}>
        <nav className="flex flex-col gap-6 items-center">
          {linksToRender.map((item, i) => <Link key={item.id || i} to={item.href || "#"} className="text-2xl font-bold text-white uppercase tracking-[0.1em] hover:text-white/60 transition-colors font-sans" onClick={() => setIsMobileMenuOpen(false)} data-index={i}>
              {item.label}
            </Link>)}
          <div className="mt-8 w-full max-w-xs">
            <Button asChild variant="default" className="w-full bg-white text-background hover:bg-neutral-200 rounded-none py-6 text-lg font-bold uppercase tracking-widest">
              <Link to="/#initiate-your-project" onClick={() => setIsMobileMenuOpen(false)}>
                Get a Quote
              </Link>
            </Button>
          </div>
        </nav>
      </div>
    </>;
}
export default function Header() {
  return <section data-section-id="10668" id="header" className="dark bg-background text-foreground">
      <MenuProvider menu_id="16">
        <HeaderContent />
      </MenuProvider>
    </section>;
}